import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { NotificationService_UnUsed } from '../_helpers/notification.service';

@Injectable()
export class ErrorsHandlerService implements ErrorHandler {

  static readonly REFRESH_PAGE_MESSAGE: string = "An error occurred: Please click this message to refresh";
  static readonly DEFAULT_ERROR_TITLE: string = "Something went wrong";

  constructor(
    private injector: Injector,
  ) { }

  handleError(error: Error | HttpErrorResponse) {
    const notificationService = this.injector.get(NotificationService_UnUsed);
    const router = this.injector.get(Router);



    if (error instanceof HttpErrorResponse) {
      // Server error happened      
      if (!navigator.onLine) {
        // No Internet connection
        return notificationService.notify('No Internet Connection');
      }
      // Http Error
      return notificationService.notify(`${error.status} - ${error.message}`);
    } else {

      notificationService.notify(`${router.url}    -  ${error.message}`);
      // Client Error Happend      
      router.navigate(['/error']);
    }
    // Log the error anyway
    console.error(error);
  }
}
